import * as ToastPrimitives from '@radix-ui/react-toast';
import clsx from 'clsx';
import { ComponentPropsWithRef } from 'react';
import { IconButton } from '../button/icon-button';
import { XmarkIcon } from '../icons/react/xmark';
import {
  toastPrimitiveClose,
  toastPrimitiveRoot,
  toastPrimitiveSubtitle,
  toastPrimitiveTitle,
  toastPrimitiveViewport,
} from './primitives.css';

const preventDefault = (e: Event) => e.preventDefault();

export const ToastViewport = function ToastViewport({
  ref,
  className,
  ...props
}: ComponentPropsWithRef<typeof ToastPrimitives.Viewport>) {
  return (
    <ToastPrimitives.Viewport
      ref={ref}
      className={clsx(toastPrimitiveViewport, className)}
      {...props}
    />
  );
};

export const ToastRoot = function ToastRoot({
  ref,
  className,
  ...props
}: ComponentPropsWithRef<typeof ToastPrimitives.Root>) {
  return (
    <ToastPrimitives.Root
      ref={ref}
      className={clsx(toastPrimitiveRoot, className)}
      onSwipeStart={preventDefault}
      onSwipeMove={preventDefault}
      onSwipeCancel={preventDefault}
      onSwipeEnd={preventDefault}
      {...props}
    />
  );
};

export const ToastTitle = function ToastTitle({
  ref,
  className,
  ...props
}: ComponentPropsWithRef<typeof ToastPrimitives.Title>) {
  return (
    <ToastPrimitives.Title
      ref={ref}
      className={clsx(className, toastPrimitiveTitle)}
      {...props}
    />
  );
};

export const ToastSubtitle = function ToastSubtitle({
  ref,
  className,
  ...props
}: ComponentPropsWithRef<typeof ToastPrimitives.Description>) {
  return (
    <ToastPrimitives.Description
      ref={ref}
      className={clsx(className, toastPrimitiveSubtitle)}
      {...props}
    />
  );
};

export const ToastClose = () => {
  return (
    <ToastPrimitives.Close aria-label="Dismiss" asChild>
      <IconButton className={toastPrimitiveClose} size="medium">
        <XmarkIcon />
      </IconButton>
    </ToastPrimitives.Close>
  );
};
